import React from "react";
import "./SubscribersTable.css";

const SubscribersTable = ({ data,page ,limit }) => {

 

  return (
    <div className="subscribers-table-wrapper">
      <table className="subscribers-table">
        <thead>
          <tr>
            <th className="td-sr">Sr.</th>
            <th>Email</th>
            
          </tr>
        </thead>

        <tbody>
          {data.map((item, index) => (
            <tr key={item.id}>
               <td className="td-sr">{(page - 1) * limit + index + 1}</td>
              <td>{item.email || "-"}</td>
              
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SubscribersTable;



